"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseThemeStyles = exports.DEFAULT_THEME = void 0;
var ui_1 = require("@creature-chess/ui");
Object.defineProperty(exports, "DEFAULT_THEME", { enumerable: true, get: function () { return ui_1.DEFAULT_THEME; } });
Object.defineProperty(exports, "createUseThemeStyles", { enumerable: true, get: function () { return ui_1.createUseThemeStyles; } });
